module.exports = __webpack_public_path__ + "static/media/19.49edcf46.mp3";